import { render, staticRenderFns } from "./FractionsNumeration.vue?vue&type=template&id=7a73b064&"
import script from "./FractionsNumeration.vue?vue&type=script&lang=js&"
export * from "./FractionsNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports